import axiosHelper  from '../utils/axios';

export default (() => {
	const networkAssetPath = "/networkAsset/airfinder/";
	const v2Path = 'v2/';

	async function bulkUpload(siteId, formData) {
		try {
			const response = await axiosHelper.getNetworkAsset().post(`${networkAssetPath}${v2Path}tags/bulk?siteId=${siteId}`, formData);
			return {
				status: response.status,
				data: response.data
			};
		} catch (error) {
			// Axios throws errors for non-2xx status codes
			// Re-throw to let the store handle it
			throw error;
		}
	}
	return {
		bulkUpload
	}
})();